import { makeStyles, tokens } from '@fluentui/react-components';

export interface HorizontalBarPoint {
  label: string;
  displayValue: string;
  /** 0-100 */
  widthPct: number;
}

interface Props {
  data: HorizontalBarPoint[];
  barColor?: string;
  labelWidth?: number;
}

const useStyles = makeStyles({
  wrap: { display: 'flex', flexDirection: 'column', gap: '12px' },
  row: { display: 'grid', gridTemplateColumns: 'var(--label-w) 1fr minmax(44px, max-content)', alignItems: 'center', gap: '10px', fontSize: '12.5px' },
  label: { color: tokens.colorNeutralForeground3 },
  track: { background: tokens.colorNeutralBackground4, borderRadius: tokens.borderRadiusMedium, height: '10px', overflow: 'hidden' },
  fill: { height: '100%', borderRadius: tokens.borderRadiusMedium },
  value: { fontWeight: 700, textAlign: 'right' },
});

/** Barras horizontales comparativas — ej. duración de rutas logísticas. */
export function HorizontalBarList({ data, barColor = tokens.colorBrandBackground, labelWidth = 110 }: Props) {
  const s = useStyles();
  return (
    <div className={s.wrap} style={{ '--label-w': `${labelWidth}px` } as React.CSSProperties}>
      {data.map(d => (
        <div key={d.label} className={s.row}>
          <span className={s.label}>{d.label}</span>
          <div className={s.track}>
            <div className={s.fill} style={{ width: `${d.widthPct}%`, background: barColor }} />
          </div>
          <span className={s.value}>{d.displayValue}</span>
        </div>
      ))}
    </div>
  );
}
